import type { DistribuicaoDialogProps } from "./types-distribuicao-dialog";
import { useDistribuicaoDialog } from "./use-distribuicao-dialog";
import { DistribuicaoDialogView } from "./view-distribuicao-dialog";

export function DistribuicaoDialog(props: DistribuicaoDialogProps) {
  const vm = useDistribuicaoDialog(props);

  return <DistribuicaoDialogView {...vm} />;
}

export type * from "./types-distribuicao-dialog";
